import { breakpoints as bp } from '../../../../src/style/variables';

/**
 * Keep all variable imports from Gumball toolkit
 */

export const breakpoints = bp;
